import { ReactNode } from "react";
import Skeleton from "react-loading-skeleton";

import MetricCardGroup from "components/MetricCard/Group";
import MetricCard from "components/MetricCard";
import Box from "ds/components/Box";

type DoraAverageProps = {
  title?: string;
  formattedValue: string;
  isLoading: boolean;
  badge?: ReactNode;
};

const DoraAverage = ({ title = "30d average", formattedValue, isLoading, badge }: DoraAverageProps) => {
  return (
    <MetricCardGroup padding="0" gap="x-large">
      <MetricCard
        title={title}
        value={
          isLoading ? (
            <Skeleton count={1} height={28} width={40} style={{ margin: "5px 0" }} />
          ) : (
            <Box gap="medium" align="center">
              {formattedValue}
              {badge}
            </Box>
          )
        }
        grow="1"
      />
    </MetricCardGroup>
  );
};

export default DoraAverage;
